module.exports = __webpack_public_path__ + "media/images/birthday/birthday-template-ru-f5f0fd5f2066df5f6f61dedfc5df3cb3.png";